import { IGroupVotingButton } from 'types/voting'
import { Heading, VotingButton } from '~elements'
import styles from './CohortVotingButtonGroup.module.scss'
import { Container } from 'react-grid-system'

const CohortVotingButtonGroup = ({ title, votingButtons }: IGroupVotingButton) => {
  return (
    <Container className={styles['cohort-wrapper']}>
      <div className={styles['cohort-container']}>
        <Heading level={2}>{title}</Heading>
        <div className={styles['cohort-buttons-container']}>
          {votingButtons &&
            votingButtons.map((vBtn, votingBtnIndex) => (
              <VotingButton key={`voting-button-${votingBtnIndex}`} {...vBtn} />
            ))}
        </div>
      </div>
    </Container>
  )
}

export default CohortVotingButtonGroup
